import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { adminApi } from '@/services/adminApi';

export function ProbeTokenButton(): JSX.Element {
  const { t } = useTranslation();
  const [token, setToken] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleMint(): Promise<void> {
    setBusy(true);
    setError(null);
    try {
      const { token: t, expiresAt: e } = await adminApi.mintProbeToken();
      setToken(t);
      setExpiresAt(e);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('admin.probeToken.mintError'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="admin-card" data-testid="probe-token-block">
      <div className="admin-card__row">
        <h2 className="admin-card__title">{t('admin.probeToken.title')}</h2>
      </div>
      <p className="muted">
        <Trans i18nKey="admin.probeToken.blurb" components={{ code: <code /> }} />
      </p>
      <button type="button" className="btn" onClick={() => void handleMint()} disabled={busy}>
        {busy ? t('admin.probeToken.minting') : t('admin.probeToken.generate')}
      </button>
      {error && <p className="error" role="alert">{error}</p>}
      {token && (
        <>
          <label className="admin-field">
            <span>{t('admin.probeToken.token')}</span>
            <input type="text" readOnly value={token} onFocus={(e) => e.currentTarget.select()} />
          </label>
          {expiresAt && <p className="muted">{t('admin.probeToken.expires', { date: new Date(expiresAt).toLocaleString() })}</p>}
        </>
      )}
    </section>
  );
}
